export interface CustomerName {
    firstName: string
    lastName: string
    middleInitial: string
}

export const CustomerNameInitialState = {
    firstName: '',
    lastName: '',
    middleInitial: ''
}


// WEBPACK FOOTER //
// ./src/typings/api-models/creditCheck/CustomerName.ts